import { ReactNode } from "react";

import CalendarIcon from "@/svgs/common-footer/calendar.svg";
import CalendarActiveIcon from "@/svgs/common-footer/calendar__active.svg";
import ChatIcon from "@/svgs/common-footer/chat.svg";
import ChatActiveIcon from "@/svgs/common-footer/chat__active.svg";
import HeartIcon from "@/svgs/common-footer/heart.svg";
import HeartActiveIcon from "@/svgs/common-footer/heart__active.svg";
import ProfileIcon from "@/svgs/common-footer/profile.svg";
import ProfileActiveIcon from "@/svgs/common-footer/profile__active.svg";
import TwoPersonsIcon from "@/svgs/common-footer/two_persons.svg";
import TwoPersonsActiveIcon from "@/svgs/common-footer/two_persons__active.svg";

export type TabValues = "members" | "favorites" | "event" | "messages" | "profile";
type TabType = {
  label: string;
  value: TabValues;
  defaultIcon: ReactNode;
  activeIcon: ReactNode;
  url: string;
};

export const TABS: TabType[] = [
  {
    label: "Members",
    value: "members",
    defaultIcon: <TwoPersonsIcon />,
    activeIcon: <TwoPersonsActiveIcon />,
    url: "/platform",
  },
  {
    label: "Favorites",
    value: "favorites",
    defaultIcon: <HeartIcon />,
    activeIcon: <HeartActiveIcon />,
    url: "/platform/favorites/liked",
  },
  {
    label: "Events",
    value: "event",
    defaultIcon: <CalendarIcon />,
    activeIcon: <CalendarActiveIcon />,
    url: "/platform/events",
  },
  {
    label: "Messages",
    value: "messages",
    defaultIcon: <ChatIcon />,
    activeIcon: <ChatActiveIcon />,
    url: "/platform/messages",
  },
  {
    label: "Profile",
    value: "profile",
    defaultIcon: <ProfileIcon />,
    activeIcon: <ProfileActiveIcon />,
    url: "/platform/profile",
  },
];
